import type { TFunction } from 'i18next';

const NOUN_KEY = /^[a-z][A-Za-z]*$/;

/**
 * A generated create's presenter names its record by `nounKey` (#3831): the
 * orchestrator never sends a noun (Finnish inflects nouns, so a noun is not a
 * value). The portal resolves `confirmation.nouns.<nounKey>` into `noun`
 * before rendering the headline or its settled action. Params without a
 * `nounKey` pass through unchanged; an unknown or malformed key yields
 * `undefined`, so the caller falls back to its generic line.
 */
export function withNoun(
  t: TFunction<'assistant'>,
  params: Record<string, string | number | boolean>,
): Record<string, string | number | boolean> | undefined {
  if (!('nounKey' in params)) return params;
  const { nounKey, ...rest } = params;
  if (typeof nounKey !== 'string' || !NOUN_KEY.test(nounKey)) return undefined;
  const missing = '\u0000missing';
  const noun: unknown = t(`confirmation.nouns.${nounKey}`, { defaultValue: missing, returnObjects: true });
  if (typeof noun !== 'string' || noun === missing) return undefined;
  return { ...rest, noun };
}
